function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import { AlertTitle, Alert as MuiAlert, Snackbar } from '@mui/material';
import { InjectableContexts, WindowedObservable } from '@procom-labs/common';
var Alert = /*#__PURE__*/ React.forwardRef(function Alert(props, ref) {
    return /*#__PURE__*/ _jsx(MuiAlert, _object_spread({
        elevation: 6,
        ref: ref,
        variant: "filled"
    }, props));
});
export var AlertContext = /*#__PURE__*/ createContext({});
var initialAlertState = {
    open: false,
    autoHide: true,
    vertical: 'top',
    horizontal: 'center',
    message: '',
    title: null,
    variant: 'filled',
    severity: 'success',
    timeout: 5000
};
export var AlertContextProvider = function(param) {
    var children = param.children;
    var _useState = _sliced_to_array(useState(initialAlertState), 2), alert = _useState[0], setAlert = _useState[1];
    var open = alert.open, title = alert.title, message = alert.message, severity = alert.severity, variant = alert.variant, vertical = alert.vertical, horizontal = alert.horizontal, timeout = alert.timeout, autoHide = alert.autoHide;
    var removeAlert = useCallback(function() {
        setAlert(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                open: false
            });
        });
    }, []);
    var addAlert = useCallback(function(param) {
        setAlert(function() {
            return _object_spread_props(_object_spread({}, initialAlertState, param), {
                open: true
            });
        });
    }, []);
    var contextValue = useMemo(function() {
        return {
            addAlert: addAlert,
            removeAlert: removeAlert
        };
    }, [
        addAlert,
        removeAlert
    ]);
    var snackBarprops = _object_spread_props(_object_spread({
        open: open
    }, autoHide && {
        autoHideDuration: timeout
    }), {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        onClose: removeAlert
    });
    useEffect(function() {
        new WindowedObservable(InjectableContexts.Alert).publish(AlertContext);
    }, []);
    return /*#__PURE__*/ _jsxs(AlertContext.Provider, {
        value: contextValue,
        children: [
            /*#__PURE__*/ _jsx(Snackbar, _object_spread_props(_object_spread({}, snackBarprops), {
                sx: {
                    zIndex: 1400
                },
                children: /*#__PURE__*/ _jsxs(Alert, {
                    onClose: removeAlert,
                    variant: variant,
                    severity: severity,
                    sx: {
                        width: '100%',
                        mt: {
                            xs: 8.5,
                            md: 0
                        }
                    },
                    children: [
                        title && /*#__PURE__*/ _jsx(AlertTitle, {
                            children: title
                        }),
                        message
                    ]
                })
            })),
            children
        ]
    });
};
